export default function ReadinessHeader({
  events,
  dashboard
}) {

  const totalObservations =
    events.length;

  const totalHighRisk =
    dashboard.reduce(
      (acc, item) =>
        acc + item.high_risk_gaps,
      0
    );

  const totalGaps =
    dashboard.reduce(
      (acc, item) =>
        acc + item.total_gaps,
      0
    );

  const avgCoverage =
    dashboard.length > 0
      ? Math.round(
          dashboard.reduce(
            (acc, item) =>
              acc + item.coverage_percent,
            0
          ) / dashboard.length
        )
      : 0;

  return (
    <div
      className="
        bg-white
        border
        rounded-2xl
        shadow-sm
        p-6
      "
    >

      <div className="flex items-start justify-between">

        <div>

          <div className="text-3xl font-bold">
            Continuous Audit Readiness
          </div>

          <div className="text-gray-500 mt-2">
            Operational evidence continuously
            transformed into structured
            compliance readiness.
          </div>

        </div>

        <div
          className="
            px-4
            py-2
            rounded-full
            bg-green-100
            text-green-700
            font-semibold
          "
        >
          {avgCoverage}% Ready
        </div>

      </div>

      <div
        className="
          grid
          grid-cols-4
          gap-4
          mt-8
        "
      >

        <Metric
          label="Operational Observations"
          value={totalObservations}
        />

        <Metric
          label="Open Audit Risks"
          value={totalGaps}
        />

        <Metric
          label="High-Risk Findings"
          value={totalHighRisk}
        />

        <Metric
          label="Readiness Coverage"
          value={`${avgCoverage}%`}
        />

      </div>

    </div>
  );
}


function Metric({
  label,
  value
}) {

  return (
    <div
      className="
        border
        rounded-xl
        p-4
        bg-gray-50
      "
    >

      <div className="text-3xl font-bold">
        {value}
      </div>

      <div className="text-sm text-gray-500 mt-2">
        {label}
      </div>

    </div>
  );
}